

                <div class="contact-wrap w-100 p-md-2">
                    <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
                    <ng-container *ngIf="!errorMessage">
                    <form *ngIf="!is_show_otp" class="contactForm" id="signupForm" [formGroup]="signupForm" method="POST">

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="emirates">Full Name</label>
                                    <input type="text" class="form-control" name="f_name" id="f_name"
                                        placeholder="Full Name" formControlName="f_name"
                                        [class.is-invalid]="signupForm.get('f_name')!.invalid && myFormSubmit">
                                    <div class="invalid-feedback">
                                        Full Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="emirates">Email</label>
                                    <input type="email" class="form-control" name="email"  placeholder="Email"
                                        formControlName="email"
                                        [class.is-invalid]="signupForm.get('email')!.invalid && myFormSubmit">
                                    <div class="invalid-feedback">
                                        Email is required.
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-md-12">
                                <div class="form-group">
                                    <input type="password" class="form-control" name="password" id="password"
                                        placeholder="Password" formControlName="password"
                                        [class.is-invalid]="signupForm.get('password')!.invalid && this.submit==true">
                                    <div class="invalid-feedback">
                                        Password is required.
                                    </div>
                                </div>
                            </div> -->
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="emirates">Phone Number</label>
                                    <div class="input-group mb-3">
                                        <span class="input-group-text" id="basic-addon1">+971</span>
                                        <input type="text" class="form-control" name="p_num" id="p_num"
                                        placeholder=" Phone Number" formControlName="p_num" maxlength="9"
                                        [class.is-invalid]="signupForm.get('p_num')!.invalid && myFormSubmit">
                                    <div class="invalid-feedback">
                                        Phone Number is required.
                                    </div>

                                        <!-- <input type="text" class="form-control" placeholder="Username"> -->
                                      </div>

                            
                                </div>
                            </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="country">Country</label>
                                        <select class="form-control" formControlName="country" [class.is-invalid]="signupForm.get('country')!.invalid && myFormSubmit">
                                            <option value="">Select Country</option>
                                            <option *ngFor="let country of countries" [value]="country.code">{{ country.name }} ({{ country.code }})</option>
                                        </select>
                                        <div class="invalid-feedback">
                                            Please select Country.
                                        </div>
                                    </div>
                                </div>
                                
                            
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="emirates">Emirates</label>
                                    <select class="form-control" formControlName="emirates" [class.is-invalid]="signupForm.get('emirates')!.invalid && myFormSubmit">
                                        <option value="">Select Emirates</option>
                                        <option *ngFor="let e of emirates" [value]="e.id">{{e.city}}</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        Please select Country.
                                    </div>
                                </div>
                            </div>
                           
                            <!-- <div class="col-md-12">
                                <div class="form-group">
                                    &nbsp;&nbsp;By clicking Sign Up, you agree to our Terms, Privacy Policy and Cookies Policy.
                                    <div class="invalid-feedback">
                                        Please accept T&C.
                                    </div>
                                </div>
                            </div> -->

                            <div class="col-md-12">
                                <div class="form-group">

                                    <button type="button" (click)="onSubmit()" id="submit"
                                        class="btn btn-primary mt-2">Send OTP</button>
                                    <!-- <div class="submitting"></div> -->
                                </div>
                            </div>
                        </div>
                    </form>

                    <div *ngIf="is_show_otp" class="contactForm">
                        <form id="otpForm" [formGroup]="otpForm">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <ng-container *ngIf="otpErrorMessage">
                                            <div class="alert alert-danger">{{ otpErrorMessage }}</div>
                                        </ng-container>
                                        <div class="form-group mb-2">
                                            <!-- Starting line -->
                                            We've sent the OTP to {{ signupForm.value.email }} and {{ signupForm.value.p_num }}. Please check your inbox and phone.
                                        </div>
                                        <h6 class="mt-2">
                                            Email OTP
                                        </h6>
                                        <input type="text" class="form-control" placeholder="OTP" formControlName="otp_email">  
                                        <span *ngIf="myOtpFormSubmit && otpForm.value['otp_email'] == ''" class="text-danger">Please enter a valid OTP for email</span>
                                        <h6 class="mt-2">
                                            Phone OTP
                                        </h6>
                                        <input type="text" class="form-control" placeholder="OTP" formControlName="otp_phone">
                                        <span *ngIf="myOtpFormSubmit && otpForm.value['otp_phone'] == ''" class="text-danger">Please enter a valid OTP for phone</span>
                                        <div class="col-md-12 mt-3 space">
                                            <div class="form-group">
                                          <p> By clicking Sign Up, you agree to our Terms, Privacy Policy and Cookies Policy.</p>
                                                <!-- <div class="invalid-feedback">
                                                    Please accept T&C.
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <!-- Both buttons are now within the same col-md-12 -->
                                                <button type="button" (click)="goBack()" class="btn btn-primary mr-2">Back</button>
                                                <button type="button" (click)="onSignUp()" id="submit" class="btn btn-primary">Sign Up</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                    </ng-container>
                    
                </div>

